export default __webpack_public_path__ + "static/past-11b636a078ae4c07d8de31879ead2b1b.svg";